import React from 'react';
import PropTypes from 'prop-types';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';

const NcHFLitesDetails = ({ selectedPayable, }) => {
  const formatMoney = (money) => {
    if (typeof money === 'string') return parseFloat(money).toFixed(2);
    return `${parseFloat(money.amount).toFixed(2)} ${money.currencyCode}`;
  };

  return (
    <>
      <FieldSet title="HF LITES Payable">
        <VerticalLabelList items={VerticalLabelList.toList({
          Id: selectedPayable.id,
          'Customer ID': selectedPayable.customerId,
          'External Account Id': selectedPayable.externalAccountId,
          'External Bill Id': selectedPayable.externalBillId,
          'Original Bill Balance': formatMoney(selectedPayable.originalBillBalance),
          'Client Reconciled Timestamp': selectedPayable.clientReconciledTimestamp,
        })}
        />
      </FieldSet>

      <FieldSet title="Transaction">
        <VerticalLabelList items={VerticalLabelList.toList({
          Id: selectedPayable.id,
          'Payment Transaction ID': selectedPayable.paymentTransactionId,
          'Payment Transaction Line Item ID': selectedPayable.paymentTransactionLineItemId,
          'Payment Amount': formatMoney(selectedPayable.paymentAmount),
          'Payment Date': selectedPayable.paymentDate,
        })}
        />
      </FieldSet>
    </>
  );
};

export default NcHFLitesDetails;

NcHFLitesDetails.propTypes = {
  selectedPayable: PropTypes.instanceOf(Object).isRequired,
};
